import { format } from "date-fns";

import { Promotion } from ".";

type Props = {
  promo: Promotion;
};

export default function PromoCard({ promo }: Props) {
  return (
    <div key={promo.id} className="mb-2 rounded-lg bg-clear-sky px-6 py-4">
      <div className="align-top">
        <span className="h-7 justify-start self-stretch font-['Open_Sans'] text-base font-semibold leading-none text-teal-950">
          {promo.description}
        </span>
      </div>
      <div className="flex justify-between self-stretch pt-6">
        <div>
          {promo.expires && (
            <>
              <span className="justify-center font-['Open_Sans'] text-sm font-light leading-none text-teal-950">
                Expires:&nbsp;
              </span>
              <span className="justify-between font-['Open_Sans'] text-sm font-semibold leading-none text-teal-950">
                {format(promo.expires, "MM/dd/yyyy")}
              </span>
            </>
          )}
        </div>
        <div>
          <img
            className="relative h-6 w-full object-contain"
            src="/logo.svg"
            alt="Restore - Hyper Wellness"
            width="80"
          />
        </div>
      </div>
    </div>
  );
}
